<template>
    <el-dialog
        title="排课记录详情"
        width="90%"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <el-table
            v-loading="loading"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }"
            :data="detailList"
            border
            max-height="500"
        >
            <el-table-column prop="teacherName" label="教师姓名"></el-table-column>
            <el-table-column prop="studentName" label="学生姓名"></el-table-column>
            <el-table-column prop="classTypeName" label="学生类型"></el-table-column>
            <el-table-column prop="educationTypeName" label="上课方式"></el-table-column>
            <el-table-column prop="categoryName" label="课程名称"></el-table-column>
            <el-table-column prop="courseDate" label="上课日期"></el-table-column>
            <el-table-column label="上课时间">
                <template slot-scope="scope">
                    <span>{{ scope.row.courseTimeOn }}-{{ scope.row.courseEndTime }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="classHour" label="课时数"></el-table-column>
            <el-table-column prop="operateTime" label="操作时间" width="160"></el-table-column>
            <el-table-column prop="operateIdName" label="操作人"></el-table-column>
            <el-table-column prop="operateTypeName" label="操作方式"></el-table-column>
        </el-table>
    </el-dialog>
</template>

<script>
import axios from 'axios'
import apiBaseUrl from '../../../config/api'

export default {
    name: 'ScheduleLogDetailDialog',

    data() {
        return {
            visible: false,
            loading: false,
            detailList: [],
        }
    },

    methods: {
        open(operateNum) {
            this.visible = true
            this.detailList = []
            this.loading = true
            axios.post(`${apiBaseUrl}/scheduleOperateLog/getLogByNum/${operateNum}`, {}, {
                headers: { 'authorization': sessionStorage.getItem('tokenInfo') }
            }).then((res) => {
                if (res.data.code === 200) {
                    this.detailList = res.data.data || []
                } else {
                    this.$message.error(res.data.message || '获取详情失败')
                }
            }).catch(() => {
                this.$message.error('获取详情失败，请稍后重试')
            }).finally(() => {
                this.loading = false
            })
        },

        handleClose() {
            this.visible = false
            this.detailList = []
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/IntelligentScheduling/components/ScheduleLogDetailDialog.vue